import React from 'react'

export const ReviewThankYouHeading: React.FC = () => {
  return (
    <h1 className='header color-pro-blue-500'>Thank you for your review!</h1>
  )
}
